import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { useTranslation } from 'react-i18next';

import PropTypes from 'prop-types';
// import { getAcadamicLevelShortHand } from 'utils/func';

export default function PaticipantFields({
  data,
  isLoading,
  formatIndex,
  formatFullname,
  formatResearcherOrganization,
}) {
  // #region Data
  const { t } = useTranslation();
  // #endregion Data

  return (
    data?.length > 0 && (
      <div className="grid">
        <div className="col-12">
          <DataTable
            value={data}
            className="p-datatable-gridlines"
            showGridlines
            dataKey="contact.id"
            loading={isLoading}
            responsiveLayout="scroll"
          >
            <Column
              header={t('formLayout.numericalOrder')}
              body={formatIndex}
              className="text-center"
            />
            <Column
              header={`${t(
                'projectProposal.general.researchHumanResources.fields.academicRank'
              )}, ${t('projectProposal.general.researchHumanResources.fields.academicDegree')}, ${t(
                'projectProposal.general.researchHumanResources.fields.name'
              )}`}
              body={formatFullname}
              style={{ minWidth: '12rem' }}
            />
            <Column
              body={formatResearcherOrganization}
              header={t('projectProposal.general.researchHumanResources.fields.organization')}
              style={{ minWidth: '12rem' }}
            />
          </DataTable>
        </div>
      </div>
    )
  );
}

PaticipantFields.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  formatIndex: PropTypes.func.isRequired,
  formatFullname: PropTypes.func.isRequired,
  formatResearcherOrganization: PropTypes.func.isRequired,
};
